import type { RegisterData } from '@/pages/auth/register/types';

interface StepReviewProps {
  data: RegisterData;
  onEdit: (step: number) => void;
}

interface RowProps {
  label: string;
  value: string;
}

function Row({ label, value }: RowProps) {
  return (
    <div className="flex items-start justify-between gap-4 border-b border-background-100 py-2.5 last:border-0">
      <span className="shrink-0 text-[13px] text-foreground-500">{label}</span>
      <span className="text-end text-[13px] font-medium text-foreground-900">
        {value || '—'}
      </span>
    </div>
  );
}

interface SectionProps {
  title: string;
  icon: string;
  step: number;
  onEdit: (step: number) => void;
  children: React.ReactNode;
}

function Section({ title, icon, step, onEdit, children }: SectionProps) {
  return (
    <div className="rounded-card border border-background-200 bg-background-50 p-4">
      <div className="mb-1 flex items-center justify-between">
        <h3 className="flex items-center gap-2 font-semibold text-sm text-foreground-900">
          <i className={`${icon} text-base text-secondary-600`} aria-hidden="true"></i>
          {title}
        </h3>
        <button
          type="button"
          onClick={() => onEdit(step)}
          className="text-[12px] font-medium text-secondary-600 transition-colors hover:text-secondary-700"
        >
          تعديل
        </button>
      </div>
      <div>{children}</div>
    </div>
  );
}

export default function StepReview({ data, onEdit }: StepReviewProps) {
  return (
    <div className="space-y-4">
      <Section title="الأساسيات" icon="ri-store-2-line" step={1} onEdit={onEdit}>
        <Row label="اسم المغسلة" value={data.name} />
        <Row label="رقم الهاتف" value={data.phone} />
        <Row label="البريد الإلكتروني" value={data.email} />
        <Row label="الوصف" value={data.description} />
        <Row label="شعار المغسلة" value={data.logoName} />
      </Section>

      <Section title="العنوان والتغطية" icon="ri-map-pin-2-line" step={2} onEdit={onEdit}>
        <Row
          label="العنوان"
          value={[data.district, data.street, data.buildingNo].filter(Boolean).join('، ')}
        />
        <Row label="عدد الأحياء المغطاة" value={`${data.coverage.length} حي`} />
        <Row label="أوقات العمل" value={`${data.openFrom} — ${data.openTo}`} />
      </Section>

      <Section title="المستندات" icon="ri-file-text-line" step={3} onEdit={onEdit}>
        <Row label="السجل التجاري" value={data.commercialRegName} />
        <Row label="الهوية" value={data.idDocName} />
        <Row label="مستندات إضافية" value={data.extraDocName} />
      </Section>
    </div>
  );
}